var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOtherSquare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 17.4951H6.66667C4.36583 17.4951 2.5 15.6293 2.5 13.3285V6.66178C2.5 4.36095 4.36583 2.49512 6.66667 2.49512H13.3333C15.6342 2.49512 17.5 4.36095 17.5 6.66178V13.3285C17.5 15.6293 15.6342 17.4951 13.3333 17.4951Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOtherSquare);
export default ForwardRef;